<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-arrow-down-up"></i>
              Nuevo movimiento de caja
            </h6>
            <button type="button" class="form-card__btn" @click="close()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">
            <div class="form-card__field">
              <label class="form-card__label" for="mov-type">Tipo de movimiento</label>
              <q-select v-model="movement.type" :options="movementTypeOptions" />
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="mov-category">Categoría de movimiento</label>
              <q-select v-if="fundCategoriesLoaded" v-model="movement.category_id" :options="categoryOptions" placeholder="- Seleccionar categoría -" />
              <div v-else class="form-card__hint">Cargando categorías...</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="mov-description">Descripción</label>
              <input id="mov-description" v-model.trim="movement.description" type="text" class="form-control" placeholder="Descripción del movimiento">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="mov-amount">Monto</label>
              <input id="mov-amount" v-model.number="movement.amount" type="number" min="0" step="0.01" class="form-control" placeholder="0.00">
            </div>
          </div>

          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="close">Cancelar</button>
            <button
              type="button"
              class="form-card__btn form-card__btn--primary"
              :disabled="!canSave || disabledSave"
              @click="saveMovement()"
            >
              <i class="bi bi-check-lg"></i>
              Guardar movimiento
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import QSelect from '@/components/shared/QSelect.vue';

const emptyMovement = (fundId) => ({
  id: null,
  type: "out",
  amount: null,
  fund_id: fundId,
  category_id: null,
  description: "",
});

export default {
  components: { QSelect },
  props: ["fundId", "balance"],
  data() {
    return {
      movement: emptyMovement(this.fundId),
      disabledSave: false,
      movementType: [
        { value: "out", text: "Salida" },
        { value: "in", text: "Entrada" },
      ],
    };
  },
  computed: {
    ...mapState('fundsCategory', {
      fundsCategories: state => state.fundsCategories,
    }),
    fundCategoriesLoaded() {
      return Array.isArray(this.fundsCategories);
    },
    filteredCategories() {
      if (!this.fundCategoriesLoaded) return [];
      return this.fundsCategories.filter(c => c.type === this.movement.type);
    },
    canSave() {
      return !!(this.movement.amount > 0 && this.movement.category_id);
    },
    movementTypeOptions() {
      return this.movementType.map(opt => ({ value: opt.value, label: opt.text }));
    },
    categoryOptions() {
      return this.filteredCategories.map(category => ({ value: category.id, label: category.name }));
    },
  },
  created() {
    this.$store.dispatch('fundsCategory/getFundsCategories');
  },
  methods: {
    saveMovement() {
      if (!this.canSave) return;
      this.disabledSave = true;
      this.$http.post("/api/funds/movement/" + this.fundId, this.movement)
        .then(() => {
          this.$emit("confirmsave");
          this.$emit('close');
        })
        .finally(() => { this.disabledSave = false; });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px 24px;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
